<template>
    <modal
            :linkClass="'action-icon'"
            :modalId="name"
            :title="'Upload document' + (file !== null ? ': ' + file.name : '')"
            :modalSize="'large'"
            :footer="true"
    >
        <template slot="modalBody">
            <div class="row">
                <div class="col-6">
                    <div class="form-group" v-if="organizations.length > 1">
                        <label :for="name+'-department'">Select the company</label>
                        <select v-model="organization" class="form-control">
                            <option disabled value="">Please select one</option>
                            <option v-for="organization in organizations" :value="organization.id" :key="organization.id">
                                {{organization.name}}
                            </option>
                        </select>
                    </div>
                    <div class="form-group" v-else>
                        <label :for="name+'-department'">Company</label>
                        <input type="text" class="form-control" disabled :value="organizations[0] ? organizations[0].name : ''">
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-group">
                        <label :for="name+'-department'">Type of document</label>
                        <select v-model="selectedCategory" class="form-control">
                            <option disabled value="">Please select one</option>
                            <option v-for="cat in categories" :value="cat.id" :key="cat.id">
                                {{cat.name}}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <form>
                            <label :for="name+'-name'">Flexworkers</label>
                            <input 
                                :name="name+'-name'"
                                :id="name+'-name'"
                                type="text"
                                class="form-control"
                                v-model="value.name">
                        </form>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div v-for="flexworker, key in filterFlexworkers()" v-bind:key="key">
                    <input type="checkbox" :id="key + '-flexworker'" :value="flexworker.id" v-model="selectedFlexworkers"/> <label v-bind:for="key + '-flexworker'" style="margin-left: 5px">{{flexworker.name}}</label>
                </div>
            </div>
        </template>
        

        <div class="modal-footer" slot="modalFooter">
            <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">
                Annuleren
            </button>
            <button type="button" class="btn btn-primary" :disabled="!selectedFlexworkers.length" @click="uploadDocument" data-dismiss="modal">
                <i class="fal fa-save mr-2"></i> Opslaan
            </button>

        </div>
    </modal>
</template>

<script>
    import Vue from 'vue';
    import vueMultiSelect from 'vue-multi-select';
    import {mapGetters} from 'vuex';
    import 'vue-multi-select/dist/lib/vue-multi-select.css';
    import store from '../../store.js';

    export default {
        data() {
            return {
                organization: {},
                selectedFlexworkers: [],
                selectedCategory: null
            };
        },
        async   created() {
            let employment = this.getEmployment

            if(employment !== null && employment.organization !== undefined) {
                this.organization = employment.organization.id
            }

            this.selectedCategory = this.category
        },
        props: ['index', 'title', 'value', 'name', 'category', 'flexworker', 'categories', 'organizations', 'file', 'flexworkers'],
        methods: {
            uploadDocument() {
                this.$emit('saveChanges', {flexworkers: [...this.selectedFlexworkers], category: this.selectedCategory});
            },
            clearSelection() {
                this.selectedFlexworkers = [];
            },
            filterFlexworkers() {
                if(typeof this.organization === 'number') {
                    return this.flexworkers.filter(flexworker => flexworker.employment.organization.id === this.organization && flexworker.name.toLowerCase().includes(this.value.name.toLowerCase()))
                }
                
                return this.flexworkers
            }
        },
        components: {
            vueMultiSelect,
        },
        computed: {
            ...mapGetters('employments', [
                'getEmployment'
            ]),
        },
        watch: {
            getEmployment(newV, oldV) {
                if(newV !== null) {
                    console.log(newV)
                    this.organization = newV.organization.id
                    store.dispatch('flexworkers/getAll', {ApiClient: Vue.prototype.$ApiClient, departments: this.$store.getters.getUserData.departments, employment_id: this.id}).then((res) => {
                        if (res.status === 200) {
                            this.flexworkers = res.data.data
                        }
                    }).catch((err) => {
                        console.log(err)
                        alert('Unexpected error downloading employments')
                    });   
                }
            },
            organizations(newV, oldV) {
                console.log(newV)
            },
            file(newV, oldV) {
                if(newV !== null) {
                }
            },
            category(newV, oldV) {
                this.selectedCategory = newV
            },
            flexworkers(newV, oldV) {
                console.log(newV)
            }
        }
    }
</script>

<style lang="scss">
@import "../../assets/scss/modal.scss";
</style>